import handleLoad from './handleLoad';

/**
 * Returns a callback to reset index and reload data.
 * @param {Element} component
 * @param {jQuery} $itemTemplate
 * @return {Function} A callback function
 */
const handleFilterReset = (component, $itemTemplate) => () => {
    $(component).find('input.select__item__input').each(function() {
        this.checked = false;
    });
    $(component).find('.filter__summary__list').empty();
    $(component).attr('data-index', 0);
    handleLoad(component, $itemTemplate)();
};

export default handleFilterReset;



// WEBPACK FOOTER //
// ./src/scripts/components/references/handleFilterReset.js